import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import MenuIcon from "@mui/icons-material/Menu";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmDeleteClient from "../../components/client-management-components/ModalConfirmDelete";
import TaskIcon from "@mui/icons-material/Task";
import UploadFileIcon from "@mui/icons-material/UploadFile";

const HandleClientActions = (props) => {
  const [clickUserDetails, setClickUserDetails] = useState(false);
  const [clickEditRoles, setClickEditRoles] = useState(false);
  const [clickDeleteRole, setClickDeleteRole] = useState(false);
  const [clickEditAccount, setClickEditAccount] = useState(false);
  const [clickApproveDocuments, setClickApproveDocuments] = useState(false);
  const [clickUploadDocuments, setClickUploadDocuments] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const { userId, data } = props;
  // console.log(props);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickRoleDetails = () => {
    handleClose();
    setClickUserDetails(true);
  };

  const handleClickEditRoles = () => {
    handleClose();
    setClickEditRoles(true);
  };

  const handleClickDelete = () => {
    handleClose();
    setIsOpen(true);
  };

  const handleClickEdit = () => {
    handleClose();
    navigate(`/clientAccount`, {
      state: { mode: "edit", data: data },
    });
  };

  const handleClickReviewDocuments = () => {
    setClickApproveDocuments(true);
  };

  const handleClickUploadDocuments = () => {
    setClickUploadDocuments(true);
  };

  useEffect(() => {
    clickApproveDocuments &&
      navigate(`/documentList/${userId}`, {
        state: { documentListBy: "client"},
      });
    clickUploadDocuments &&
      navigate(`/uploadDocuments/${userId}`, {
        state: { uploadBy: "client", documentType: data?.document?.type, userId: userId},
      });
  }, [clickApproveDocuments, clickUploadDocuments]);

  return (
    <>
      <IconButton onClick={handleClick} size="small">
        <MenuIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        keepMounted
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 210,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
      >
        <MenuItem onClick={handleClickEditRoles}>
          <ListItemIcon>
            <EditIcon />
          </ListItemIcon>
          <ListItemText>{t("clientOptions.item-1")}</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleClickEdit}>
          <ListItemIcon>
            <EditIcon />
          </ListItemIcon>
          <ListItemText>{t("clientOptions.item-2")}</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleClickDelete}>
          <ListItemIcon>
            <DeleteIcon />
          </ListItemIcon>
          <ListItemText>{t("clientOptions.item-3")}</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleClickReviewDocuments}>
          <ListItemIcon>
            <TaskIcon />
          </ListItemIcon>
          <ListItemText>{t("clientOptions.item-4")}</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleClickUploadDocuments}>
          <ListItemIcon>
            <UploadFileIcon />
          </ListItemIcon>
          <ListItemText>{t("clientOptions.item-5")}</ListItemText>
        </MenuItem>
      </Menu>
      <ConfirmDeleteClient
        isOpen={isOpen}
        handleClose={handleCloseModal}
        userId={userId}
        data={data}
      />
    </>
  );
};

const HeadersClient = () => {
  const { t } = useTranslation();

  const columns = [
    {
      field: "actions",
      type: "actions",
      width: 100,
      renderCell: (params) => {
        const userId = params?.row?.id;
        return <HandleClientActions data={params?.row} userId={userId} />;
      },
    },
    {
      field: "id",
      headerName: `ID`,
      width: 100,
    },
    {
      field: "forename",
      headerName: t("superadminList.headers-1"),
      width: 200,
    },
    {
      field: "surname",
      headerName: t("superadminList.headers-2"),
      width: 200,
    },
    {
      field: "email",
      headerName: t("superadminList.headers-3"),
      width: 250,
    },
    // {
    //   field: "phone",
    //   headerName: t("superadminList.headers-4"),
    //   width: 250,
    // },
    // {
    //   field: "document",
    //   headerName: t("superadminList.headers-5"),
    //   width: 250,
    // },
  ];
  return columns;
};

export default HeadersClient;
